import axios from "axios";
import React, { useState, useEffect, useCallback } from "react";
// import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiKey } from "../../config/config";
import { languageHelper } from "../../config/helperFunctions";
import { toast } from "react-toastify";

function POSRightHeader() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showModalView, setShowModalView] = useState(false);
  const [deposits, setDeposits] = useState([]);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    amount: "",
    date: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.id]: e.target.value });
  };

  const handleLogout = () => {
    axios
      .post(
        `${apiKey}/api/rms/admin/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {})
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        localStorage.removeItem("rms-admin");
        navigate("/admin");
      });
  };

  const handleSubmit = async () => {
    if (!form.name || !form.phone || !form.amount || !form.date) {
      setAlert({ type: "error", msg: "All required fields must be filled." });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${apiKey}/api/rms/admin/deposit`, form, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
      setAlert({ type: "success", msg: "Deposit added successfully!" });
      setForm({ name: "", phone: "", amount: "", date: "", description: "" });
      toast.success(res.data.message || "Success");
    } catch (err) {
      setAlert({ type: "error", msg: "Failed to add deposit." });
    } finally {
      setLoading(false);
    }
  };

  const fetchDeposits = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiKey}/api/rms/admin/pos_deposit`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
      setDeposits(res.data.data || []);
    } catch (err) {
      console.error("Error fetching deposits:", err);
    } finally {
      setLoading(false);
    }
  }, [user?.token]);

  useEffect(() => {
    if (showModalView) {
      fetchDeposits();
    }
  }, [fetchDeposits, showModalView]);

  return (
    <header className="my-2">
      <div className="bg-white px-2 py-1 flex flex-wrap justify-end gap-1 items-center text-xs rounded-tl-2xl">
        {/* Comming Soon */}
        {/* <select
          className="bg-white w-20 h-8 border border-[#774D96] rounded-md"
          name=""
          id=""
        >
          <option>Select</option>
          <option value=""></option>
        </select>
        <div className="group relative">
          <button className="border border-[#774D96] bg-white px-2 py-1 rounded-md text-xs flex items-center gap-x-1">
            <span>Notify</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="10"
              width="8"
              viewBox="0 0 448 512"
            >
              <path d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" />
            </svg>
            <span className="text-red-500">(1)</span>
          </button>
          <div className="absolute top-0 left-0 w-[80px] hidden cursor-pointer group-hover:block">
            <div className="bg-[#f9f9f9] shadow-xl w-56 max-h-72 overflow-y-auto mt-8">
              <div className="p-2">
                <h2 className="text-lg font-semibold text-[#774D96]">
                  Notification
                </h2>
              </div>
              <div className="text-md">
                <div>
                  <span className="flex gap-x-4 px-4 py-4 cursor-pointer hover:bg-[#f1f1f1]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="16"
                      width="14"
                      viewBox="0 0 448 512"
                      fill="#774D96"
                    >
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
                    </svg>
                    <span>
                      Ingredients in Alert (
                      <span className="text-red-500">11</span>)
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button className="bg-[#774D96] px-3 py-2 rounded fill-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="14"
            width="12"
            viewBox="0 0 576 512"
          >
            <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
          </svg>
        </button>
        <button className="bg-[#774D96] px-3 py-2 rounded fill-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="14"
            width="14"
            viewBox="0 0 512 512"
          >
            <path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z" />
          </svg>
        </button>
        <button className="bg-[#774D96] px-3 py-2 rounded fill-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="14"
            width="14"
            viewBox="0 0 512 512"
          >
            <path d="M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z" />
          </svg>
        </button> */}
        <button
          onClick={() => setShowModalView(true)}
          className="bg-d-cat-btn px-3 py-2 rounded fill-white transition"
          title="View Deposits"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="14"
            width="14"
            viewBox="0 0 24 24"
          >
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 8 12 8s4.5 2.01 4.5 4.5S14.49 17 12 17zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z" />
          </svg>
        </button>
        <button
          onClick={() => setShowModal(true)}
          className="bg-d-cat-btn px-3 py-2 rounded fill-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="14"
            width="14"
            viewBox="0 0 512 512"
          >
            <path d="M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32zm0 96c17.7 0 32 14.3 32 32v64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64v-64c0-17.7 14.3-32 32-32z" />
          </svg>
        </button>
        {showModalView && (
          <div className="absolute top-0 left-0 w-full min-h-screen inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-20 z-50">
            <div className="bg-white w-[90%] md:w-[700px] rounded-xl shadow-xl p-6 relative max-h-[80vh] overflow-y-auto">
              <h2 className="text-xl font-semibold text-d-cat-btn mb-4">
                {languageHelper("Deposits List")}
              </h2>

              <button
                onClick={() => setShowModalView(false)}
                className="absolute top-3 right-4 text-gray-500 hover:text-gray-700"
              >
                ✖
              </button>

              {loading ? (
                <p className="text-center py-4">
                  {languageHelper("Loading...")}
                </p>
              ) : deposits.length > 0 ? (
                <table className="w-full border border-gray-200">
                  <thead>
                    <tr className="bg-gray-100 text-sm text-gray-700">
                      <th className="p-2 border">#</th>
                      <th className="p-2 border">{languageHelper("Name")}</th>
                      <th className="p-2 border">{languageHelper("Phone")}</th>
                      <th className="p-2 border">{languageHelper("Amount")}</th>
                      <th className="p-2 border">{languageHelper("Date")}</th>
                      <th className="p-2 border">
                        {languageHelper("Description")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {deposits.map((d, index) => (
                      <tr key={d.id} className="text-sm hover:bg-gray-50">
                        <td className="p-2 border text-center">{index + 1}</td>
                        <td className="p-2 border">{d.name}</td>
                        <td className="p-2 border">{d.phone}</td>
                        <td className="p-2 border text-right">{d.amount}</td>
                        <td className="p-2 border text-center">
                          {new Date(d.date).toLocaleString()}
                        </td>
                        <td className="p-2 border">{d.description || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-center py-4 text-gray-600">
                  {languageHelper("No deposits found.")}
                </p>
              )}
            </div>
          </div>
        )}
        {showModal && (
          <div
            onClick={() => setShowModal(false)}
            className="absolute top-0 left-0 w-full min-h-screen inset-0 bg-black/50 flex items-center justify-center z-50"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="bg-white rounded-lg shadow-xl w-full max-w-md p-6"
            >
              <h1 className="text-xl font-semibold mb-4 text-center">
                Add Deposit
              </h1>

              {alert && (
                <div
                  className={`p-2 mb-3 text-center rounded ${
                    alert.type === "success"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {alert.msg}
                </div>
              )}

              <div className="space-y-3">
                <div>
                  <label className="block text-sm font-medium">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full border rounded px-3 py-2"
                    type="text"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">
                    Phone <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="phone"
                    value={form.phone}
                    onChange={handleChange}
                    className="w-full border rounded px-3 py-2"
                    type="text"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">
                    Amount <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="amount"
                    value={form.amount}
                    onChange={handleChange}
                    className="w-full border rounded px-3 py-2"
                    type="number"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">
                    Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="date"
                    value={form.date}
                    onChange={handleChange}
                    className="w-full border rounded px-3 py-2"
                    type="datetime-local"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">
                    Description
                  </label>
                  <textarea
                    id="description"
                    value={form.description}
                    onChange={handleChange}
                    className="w-full border rounded px-3 py-2"
                    rows="2"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-2 mt-5">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Close
                </button>
                <button
                  disabled={loading}
                  onClick={handleSubmit}
                  className="px-4 py-2 bg-d-cat-btn text-white rounded hover:bg-[#6b3b8f]"
                >
                  {loading ? "Saving..." : "Add Deposit"}
                </button>
              </div>
            </div>
          </div>
        )}
        <Link
          className="bg-d-cat-btn px-3 py-2 rounded fill-white text-white flex gap-x-1 items-center justify-center"
          to={"/admin/allsales"}
        >
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            class="size-[14px]"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path>
          </svg>
        </Link>
        <button
          onClick={() => window.location.reload()}
          className="bg-d-cat-btn px-3 py-2 rounded fill-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="14"
            width="14"
            viewBox="0 0 512 512"
          >
            <path d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z" />
          </svg>
        </button>
        {/* Comming Soon */}
        <Link
          to={"/admin/home"}
          className="bg-d-cat-btn px-3 py-2 rounded fill-white text-white flex gap-x-1 items-center justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="14"
            width="12"
            viewBox="0 0 448 512"
          >
            <path d="M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z" />
          </svg>
          <span>{languageHelper("CPanel")}</span>
        </Link>
        <button
          onClick={handleLogout}
          className="bg-d-cat-btn px-3 py-2 rounded fill-white text-white flex gap-x-1 items-center justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="14"
            width="14"
            viewBox="0 0 512 512"
          >
            <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z" />
          </svg>
          <span>{languageHelper("Logout")}</span>
        </button>
      </div>
    </header>
  );
}

export default POSRightHeader;
